/* Caselier collection behaviour: day/night mode toggle + card glow retinting.
 * Loaded deferred from layout/theme.liquid. The initial mode attribute is set
 * by an inline pre-paint script in theme.liquid; this file only handles changes.
 */
(function () {
  'use strict';

  /* ----- day/night toggle ----- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cas-mode-toggle]');
    if (!btn) return;
    var next = document.documentElement.getAttribute('data-cas-mode') === 'night' ? 'day' : 'night';
    document.documentElement.setAttribute('data-cas-mode', next);
    try { localStorage.setItem('cas_mode', next); } catch (err) { /* private browsing */ }
  });

  /* ----- card glow: retint when a variant swatch is hovered or selected -----
     Extracts the dominant hue of the swatch thumbnail; mirrors the server-side
     zbuild-card-glow.mjs script that sets the per-product default metafield. */

  var NEUTRAL = 'rgba(255,255,255,0.10)';
  var cache = Object.create(null);

  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var l = (max + min) / 2, d = max - min, h = 0, s = 0;
    if (d) {
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s, l];
  }

  function glowFromImage(img) {
    var c = document.createElement('canvas');
    c.width = 32; c.height = 32;
    var ctx = c.getContext('2d');
    ctx.drawImage(img, 0, 0, 32, 32);
    var d = ctx.getImageData(0, 0, 32, 32).data;
    var x = 0, y = 0, wsum = 0, ssum = 0, n = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) continue;
      var hsl = rgbToHsl(d[i], d[i + 1], d[i + 2]);
      if (hsl[2] < 0.08 || hsl[2] > 0.94) continue;
      ssum += hsl[1]; n++;
      if (hsl[1] < 0.18) continue;
      var rad = hsl[0] * Math.PI / 180;
      x += Math.cos(rad) * hsl[1];
      y += Math.sin(rad) * hsl[1];
      wsum += hsl[1];
    }
    if (!wsum || (n && ssum / n < 0.06)) return null;
    var hue = Math.round(((Math.atan2(y, x) * 180 / Math.PI) + 360) % 360);
    return 'hsla(' + hue + ', 70%, 58%, 0.32)';
  }

  function extract(url, cb) {
    if (cache[url]) return cb(cache[url]);
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      var v = NEUTRAL;
      try { v = glowFromImage(img) || NEUTRAL; } catch (e) { /* tainted canvas: keep neutral */ }
      cache[url] = v;
      cb(v);
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }

  function swatchUrl(label) {
    var sw = label.querySelector('.swatch');
    if (!sw) return null;
    var m = /--swatch-background:\s*url\((['"]?)([^'")]+)\1\)/.exec(sw.getAttribute('style') || '');
    return m ? m[2] : null;
  }

  function handle(e, commit) {
    var label = e.target.closest && e.target.closest('.variant-option__swatch label');
    if (!label) return;
    var card = label.closest('.cas-card--glow, .cas-fp--glow');
    if (!card) return;
    /* White-glow mode pins every card to neutral white; never retint. */
    if (card.classList.contains('cas-card--glow-white') || card.classList.contains('cas-fp--glow-white')) return;
    if (card.dataset.casGlowBase == null) {
      card.dataset.casGlowBase = card.style.getPropertyValue('--cas-glow').trim();
    }
    var url = swatchUrl(label);
    if (!url) return;
    extract(url, function (glow) {
      if (!glow) return;
      card.style.setProperty('--cas-glow', glow);
      if (commit) card.dataset.casGlowBase = glow;
    });
  }

  document.addEventListener('click', function (e) { handle(e, true); });
  document.addEventListener('pointerover', function (e) { handle(e, false); });
  document.addEventListener('pointerout', function (e) {
    var label = e.target.closest && e.target.closest('.variant-option__swatch label');
    if (!label) return;
    var card = label.closest('.cas-card--glow, .cas-fp--glow');
    if (card && card.dataset.casGlowBase) {
      card.style.setProperty('--cas-glow', card.dataset.casGlowBase);
    }
  });

  /* ----- device-collection model preselect -----
     On device collections (window.__casCollectionModel set by theme.liquid),
     clicking a product stores a one-shot sessionStorage handoff that
     cas-options.js consumes on the product page to preselect this
     collection's model (priority over the remembered cas_model). Deliberately
     not passed via the URL: a lingering ?model= param reads as stale once the
     visitor changes the dropdown. */

  if (window.__casCollectionModel) {
    var markModel = function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('a[href*="/products/"]')) {
        /* Horizon cards navigate on clicks anywhere in the card (often the
           image, outside the anchor), except on interactive elements like
           swatches and quick-add - mirror product-card.js's guard. */
        var card = t.closest('product-card');
        if (!card) return;
        if (t.closest('button, input, label, select, a, [tabindex="1"]')) return;
      }
      try { sessionStorage.setItem('cas_collection_model', window.__casCollectionModel); } catch (err) { /* private browsing */ }
    };
    /* capture phase so the handoff lands before any navigation handler runs;
       auxclick covers middle-click (session storage copies into tabs opened
       from links) */
    document.addEventListener('click', markModel, true);
    document.addEventListener('auxclick', markModel, true);
  }
})();
